module.exports = __webpack_public_path__ + "static/media/ad-post-banner-on-detail-mockup-upper.d6376965.png";